var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"section"},[_c('PackagesTargetedRange',{attrs:{"target":"Car","altTarget":"Vehicle/Engine","brandTarget":"brand of vehicle"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }